<template>
	<inertia-head title="Account Expired Special Renew" />

	<div v-if="flash" class="shadow m-3 border border-default bg-white" :class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'">
		<div class="content">
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
			<p class="mb-0">
				{{ flash.message }}
			</p>
		</div>
	</div>
	<h2>Welcome back {{ user.fname }}!</h2>
	<div class="block-rounded">
		<div class="block-header text-center">
			<h3 class="block-title">CURRENT SUBSCRIPTION</h3>
		</div>
		<div class="block-content bg-primary-light text-center">
			<div class="h3 fw-bold mb-0">
				{{ user.current_rank }} {{ user.add_alias }}
			</div>
			<div class="fs-sm fw-semibold mb-3">
				{{membership_type}}
			</div>
		</div>
	</div>
	<p class="text-center my-5">Your subscription has expired last <b class="text-danger">{{user.expiry_format}}</b>.</p>
	<form @submit.prevent="renew">
		<div class="row">
			<div class="col-md-6 mb-4">
				<div v-if="form.errors.subscription" class="alert alert-danger">
					<p class="fw-semibold mb-0">{{ form.errors.subscription }}</p>
				</div>
				<div class="row">
					<div class="col-12">
						<p class="fw-bold mb-1">Choose Subscriptions</p>
						<div
							class="col-12"
							v-for="subscription in products"
							:key="subscription.prod_id"
						>
							<div class="form-check form-block mb-3">
								<input
									v-model="form.subscription"
									class="form-check-input"
									type="radio"
									:value="subscription.prod_id"
									:id="subscription.prod_id"
									name="subscription"
								/>
								<label class="form-check-label" :for="subscription.prod_id">
									<span class="d-flex align-items-center">
										<h6 class="fs-sm mb-0">
											{{ subscription.membership }}
										</h6>
										<span v-if="subscription.add_display" class="badge bg-warning ms-1">
											{{ subscription.add_display }}
										</span>
									</span>
									<small>
										<s v-if="subscription.is_promo==1" class="me-1">&#8369;{{ subscription.regular_amount }}</s>
										<span :class="{'fw-bold text-danger':subscription.is_promo==1}">&#8369;{{ subscription.amount }}</span>
										<div v-if="subscription.add_desc!=null">
											<div v-html="subscription.add_desc"></div>
										</div>
									</small>
								</label>
							</div>
						</div>	
					</div>
					<!-- <div
						class="col-12"
						v-for="(subscription,index) in products"
						:key="subscription.prod_id"
					>
						<div class="form-check form-block mb-3">
							<input
								v-model="form.subscription"
								class="form-check-input"
								type="radio"
								:value="subscription.prod_id"
								:id="subscription.prod_id"
								name="subscription"
							/>
							<label class="form-check-label" :for="subscription.prod_id">
								<span class="d-flex align-items-center">
									<h6 class="fs-sm mb-0">
										{{ subscription.membership }}
									</h6>
									<span
										v-if="subscription.add_display"
										class="badge bg-warning ms-1"
									>
										{{ subscription.add_display }}
									</span>
								</span>
								<small>&#8369;{{ subscription.amount }}</small>
							</label>
						</div>
					</div> -->
				</div>
			</div>
			<div class="col-md-6 mb-4">
				<h6 class="fw-semibold">Choose Payment Method</h6>
				<div class="row">
					<div class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								value="CARD"
								id="card"
								name="payment_method"
							/>
							<label class="form-check-label" for="card">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/stripe-logo.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 80px;
									"
								>
								</span>
							</label>
						</div>
					</div>
					<div v-if="payment_available==true" class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								:value="'DRAGONPAY'"
								id="dragonpay"
								name="payment_method"
							/>
							<label class="form-check-label" for="dragonpay">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/dragonpay.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 80px;
									"
								>
								</span>
							</label>
						</div>
					</div>
					<div v-if="payment_available==true" class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								:value="'DRAGONPAY-GCASH'"
								id="dragonpay_gcash"
								name="payment_method"
							/>
							<label class="form-check-label" for="dragonpay_gcash">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/gcash.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 80px;
									"
								>
								</span>
							</label>
						</div>
					</div>
					<!-- <div class="col-4">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								:value="'BROPAY'"
								id="bropay"
								name="payment_method"
							/>
							<label class="form-check-label" for="bropay">
								<span
									class="d-flex align-items-center"
									style="
										background-image: url(/media/logo/bropay-logo.png);
										background-size: contain;
										background-repeat: no-repeat;
										background-position: center;
										height: 80px;
									"
								>
								</span>
							</label>
						</div>
					</div> -->
				</div>
				<div v-if="form.payment_method == 'CARD'">
					<div v-if="has_card">
						<div class="form-check form-switch mb-4">
							<input
								v-model="form.use_existing_card"
								class="form-check-input"
								type="checkbox"
								:value="true"
								id="example-switch-default1"
								name="example-switch-default1"
							/>
							<label class="form-check-label" for="example-switch-default1">
								Use existing card
							</label>
						</div>
						<div v-if="form.use_existing_card" class="mb-4">
							<p class="mb-0">
								<span class="fw-semibold">CARD:</span>
								<i>**** **** **** {{ card.last4 }}</i>
								<span class="badge bg-primary ms-2">{{ card.brand }}</span>
							</p>
						</div>
					</div>
					<div v-if="!form.use_existing_card" class="form-group mb-4">
						<stripe @accept-token="acceptToken" ref="stripe" />
						<div v-if="form.errors.card" class="invalid-feedback d-block">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.card }}
						</div>
					</div>
				</div>
				<div class="mb-4 text-end space-x-1">
					<inertia-link
						v-if="!form.processing"
						:href="route('post.logout')"
						method="post"
						as="button"
						class="btn btn-alt-secondary"
					>
						Logout
					</inertia-link>
					<button
						class="btn btn-alt-primary"
						:disabled="
							form.processing ||
							!form.subscription ||
							(form.payment_method === 'CARD' &&
								!form.use_existing_card &&
								!form.token)
						"
					>
						
						<span v-if="!form.processing">Renew Now!</span>
						<span v-else>
							<div class="spinner-border spinner-border-sm text-dark" role="status" >
								<span class="sr-only mr-1">Please wait...</span>
							</div>
							<span class="mx-2">Please wait...</span>
						</span>
					</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { useForm } from '@inertiajs/inertia-vue3'
import GuestLayout from '../../Layouts/GuestLayout'
import Stripe from '../../Shared/Components/Stripe'
import { watch, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: GuestLayout,
	props: {
		user: Object,
		membership_type: String,
		test: String,
		products: Object,
		has_card: Boolean,
		card: Object,
		flash: Object,
		flash1: Object,
		rebates: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		const toast = createToaster();

		const payment_available = ref(true);

		const form = useForm({
						subscription: null,
						payment_method: 'CARD',
						pmethod: null,
						pchannel: null,
						token: null,
						use_existing_card: props.has_card?true:false,
						action: 'renew',
						rebates: props.rebates,
						test 	: props.test
					})

		const acceptToken = (token) => {
								form.token = token
							}

		const renew = () => {
						form.post(route('member.account-expired.renew'), {
							preserveScroll: false,
							// only: ['flash1'],
							// onSuccess: () => {
							// 	if(props.flash1.result=="success")
							// 	{
							// 		toast.show(props.flash1.message, { type: "success"});
							// 		setTimeout(() => Inertia.visit(route('member.home')), 4000);
							// 	}
							// }
						})
					}

		watch(
			() => form.payment_method,
			(payment_method) => {
				
				form.pmethod 	= null;
				form.pchannel 	= null;	

				if(payment_method=='CARD' && props.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;

					if(payment_method=='DRAGONPAY-GCASH')
					{
						form.pmethod 	= 'GCASH';
						form.pchannel 	= 'GCSH';
					}
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M"))
			{
				form.payment_method = 'CARD';
				payment_available.value = false;

				form.pmethod 	= null;
				form.pchannel 	= null;	
				
			}else
			{
				payment_available.value = true;
			}
		})

		return {
			toast,
			form,
			renew,
			payment_available,
			acceptToken,
		}
	},
}
</script>
